/**
 * Expand a string to an array of integers
 *
 * @param key hyphen separated integers in a string; ex: "34-78"
 * @returns {number[]}
 */
export const expandRange = key => {
  const range = key.split("-");
  const start = Number.parseInt(range[0], 10);
  const stop = Number.parseInt(range[1], 10);
  const size = stop + 1 - start;
  console.assert(size > 0, {
    start: start,
    stop: stop,
    errorMsg: "start is not less than stop"
  });
  return Array(size)
    .fill()
    .map((_, i) => start + i);
};

export const compositeKeyString = (
  compositeKey,
  separator = "/",
  clean = false,
  translateFunction
) => {
  var elements = [
    compositeKey.product,
    compositeKey.subProduct,
    compositeKey.geography,
    compositeKey.subGeography
  ];
  if (clean) {
    elements = elements.filter(e => e > "");
  }
  if (translateFunction) {
    elements = elements.map(e =>
      translateFunction({ id: e, defaultMessage: e })
    );
  }
  return elements.join(separator);
};

export const frameKeyString = active => {
  return `${active.panel.id}_${active.frameList.id}`;
};

export const imageKeyString = active => {
  return `${active.frameList.id}_${active.frame.id}`;
};

export const randomCompositeKey = () => {
  const subProduct = ["CLDWX", "TURBC"];
  const geography = [
    "GFACN31",
    "GFACN32",
    "GFACN33",
    "GFACN34",
    "GFACN35",
    "GFACN36",
    "GFACN37"
  ];
  return {
    product: "GFA",
    subProduct: subProduct[Math.floor(Math.random() * subProduct.length)],
    geography: geography[Math.floor(Math.random() * geography.length)],
    subGeography: ""
  };
};
